var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlayRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 8,
    viewBox: "0 0 9 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.23297 4.83766C7.95131 5.44804 7.09183 5.90643 5.37287 6.8232C3.8207 7.65103 3.04461 8.06494 2.41116 7.98324C1.85829 7.91194 1.36027 7.61312 1.03718 7.15886C0.666992 6.63837 0.666992 5.75881 0.666992 3.99967C0.666992 2.24054 0.666991 1.36098 1.03718 0.840494C1.36027 0.386226 1.85829 0.0874127 2.41116 0.0161055C3.04461 -0.0655958 3.8207 0.348318 5.37287 1.17615C7.09183 2.09292 7.95131 2.55131 8.23297 3.16169C8.47833 3.69341 8.47833 4.30594 8.23297 4.83766Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlayRight);
export default __webpack_public_path__ + "static/media/play-right.5dc302302fb880b720ce44f2bf94d1b6.svg";
export { ForwardRef as ReactComponent };